import useTrackObj from "./useTrackObj"

const trackEvent = (type, trackProps) => {
  const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined"
  if (!isBrowser) return
  window.dataLayer = window.dataLayer || []
  window.utag_data = window.utag_data || {}

  const data = useTrackObj(type, trackProps)
  dataLayer.push({ ...data })
  if (window.utag) {
    utag.link({ ...data })
  } else {
    window.utag_data = { ...data }
  }
}
export default trackEvent
